import { gql } from "@apollo/client";

import performanceAssessmentChartLabelQuestionFragment from "./performance-assessment-chart-label-question-fragment";

export default gql`
  ${performanceAssessmentChartLabelQuestionFragment}
  query getPerformanceAssessmentChartLabels($questionIds: [Int]!) {
    performanceAssessmentChartLabels(questionIds: $questionIds) {
      edges {
        node {
          id
          label
          questionOne {
            ...PerformanceAssessmentChartLabelQuestion
          }
          questionTwo {
            ...PerformanceAssessmentChartLabelQuestion
          }
          questionOneIntegerAnswer
          questionTwoIntegerAnswer
        }
      }
    }
  }
`;
